/* @flow */
import * as React from 'react';
import Text from 'components/Text';
import List from 'components/List';
import Radio from 'components/Radio';
import Divider from 'components/Divider';
import ListItem from 'components/ListItem';

import './styles/PreferredVoiceCallDevice.scss';

type Props = {
  devices: *,
  setPreferredVoiceCallsDevice: (device: *) => void,
};

class PreferredVoiceCallDevice extends React.Component<Props> {
  renderDevice = (device: *) => {
    return (
      <ListItem key={device.id}>
        <Radio
          label={device.label}
          checked={device.is_preferred_voice_calls_device}
          onChange={() => this.props.setPreferredVoiceCallsDevice(device)}
        />
      </ListItem>
    );
  };

  render() {
    if (this.props.devices.length <= 0) {
      return null;
    }

    return (
      <div className="PreferredVoiceCallDevice">
        <Divider size="small" />
        <Text color="thunder">
          This number must match the mobile phone you use to make and receive calls on Remind. It
          will not be shared with anyone.
        </Text>
        <List size="medium">{this.props.devices.map(this.renderDevice)}</List>
      </div>
    );
  }
}

export { PreferredVoiceCallDevice };
export default PreferredVoiceCallDevice;
